// Work-history phone formatting depends on the employer/school country.
export const usesNorthAmericanPhone = (country) =>
  ["canada", "ca", "us", "usa", "u.s.", "u.s.a.", "united states", "united states of america"].includes(String(country || "").trim().toLowerCase());

export function formatWorkHistoryPhone(value, country) {
  if (!usesNorthAmericanPhone(country)) return String(value ?? "");
  let digits = String(value ?? "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
  digits = digits.slice(0, 10);
  if (!digits) return "";
  if (digits.length < 3) return `(${digits}`;
  if (digits.length === 3) return `(${digits})`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)})-${digits.slice(3)}`;
  return `(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
